import {
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
} from "@aws-amplify/ui-react";
import React, { useCallback, useEffect, useState } from "react";
import { createSession, startVerification } from "../../services/faceLiveness";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { images } from "../../assets";
import {
  Box,
  Grid,
  Typography,
  Button,
  Link,
  Paper,
  Container,
} from "@mui/material";
import en from "../../locales/en.json";
import es from "../../locales/es.json";
import it from "../../locales/it.json";
import Loading from "../loadingScreen";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

const locales = { en, es, it };

const LivenessDetector = () => {
  const [loading, setLoading] = useState(false);
  const { sessionId } = useParams();
  const [awsSessionId, setAwsSessionId] = useState("");
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");
  const t = locales[language];

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const token = queryParams.get("token");

  //   if (!token) {
  //     navigate("/404");
  //     return;
  //   }
  // }, []);

  // const fetchCreateLiveness = async (token) => {
  //   if (!token) {
  //     navigate("/404");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const response = await createSession(
  //       {
  //         age_limit: 50,
  //         external_id: Math.random().toString(36).substring(2, 15),
  //         redirect_url: `https://5rdvd40k-3002.inc1.devtunnels.ms/`,
  //       },
  //       token
  //     );

  //     // if (response.status === 200 || response.status === 201) {
  //     let sessionId = response?.data?.verification_url?.split("/").pop();

  //     console.log("sessionId", sessionId);

  //     navigate(`/verification/${sessionId}`, {
  //       state: {
  //         age_limit: 50,
  //         language: language,
  //       },
  //     });

  //     // } else {
  //     console.log("response", response);
  //     // }
  //   } catch (error) {
  //     console.log(error, "errorerrorerror");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const credentialsProvider = fromCognitoIdentityPool({
    client: new CognitoIdentityClient({ region: "eu-west-1" }),
    identityPoolId: "eu-west-1:9735e824-f04a-4c3c-84ad-ccac69ef5480",
  });

  const initiateVerification = useCallback(async () => {
    setLoading(true);

    try {
      const response = await startVerification(sessionId);

      if (response?.status === 200 || response?.status === 201) {
        const sessionKey = response?.data?.aws_session_id;
        // Fetch actual credentials and log them to debug
        const creds = await credentialsProvider();
        const keys = response?.data;

        if (sessionKey) {
          setAwsSessionId(sessionKey);
          navigate(`/process/${sessionId}`, {
            state: {
              age_limit: 18,
              awsSessionId: sessionKey,
              language: language,
              keys: creds,
            },
          });
        } else {
          console.error("Invalid aws_session_id received");
          navigate("/failed");
        }
      } else {
        console.error("Unexpected response status:", response?.status);
        setError(new Error("Verification failed with unexpected status."));
        navigate("/failed");
      }
    } catch (error) {
      console.error("Failed to start verification:", error);
      setError(error);
      navigate("/failed");
    } finally {
      setLoading(false);
    }
  }, [sessionId, language]);

  // const handleStartVerification = () => {
  //   const queryParams = new URLSearchParams(window.location.search);
  //   const token = queryParams.get("token");

  //   if (!token) {
  //     navigate("/404");
  //     return;
  //   }

  //   initiateVerification();
  // };

  return (
    <ThemeProvider>
      <>
        {loading ? (
          // <div
          //   style={{
          //     display: "flex",
          //     justifyContent: "center",
          //     alignItems: "center",
          //     height: "100vh",
          //     flexDirection: "column",
          //   }}
          // >
          //   <img src={images.spinner} />
          //   <Typography color="primary.text">
          //     {t.landingPage.cameraAuthorization}
          //   </Typography>
          // </div>
          <Loading text={t.landingPage.cameraAuthorization} />
        ) : (
          <>
            <Box sx={{ backgroundColor: "#f5f5f7", minHeight: "100vh" }}>
              {/* Logo */}

              <Box
                display="flex"
                justifyContent="flex-end"
                sx={{ px: 2, pt: 1 }}
              >
                <FormControl size="small" sx={{ minWidth: 120 }}>
                  <Select
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="en">English</MenuItem>
                    <MenuItem value="es">Español</MenuItem>
                    <MenuItem value="it">Italiano</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              <Box
                display="flex"
                justifyContent="center"
                sx={{ pt: { xs: 1, md: 1 } }}
              >
                <img
                  src={images.certageLogo}
                  alt="Logo"
                  style={{
                    width: "min(70vw, 300px)",
                    height: "auto",
                    maxHeight: "140px",
                  }}
                />
              </Box>

              <Container
                maxWidth="lg"
                sx={{ px: { xs: 1, sm: 2, md: 4 }, py: 1 }}
              >
                <Typography
                  textAlign="center"
                  fontFamily="Inter, sans-serif"
                  color="#3F4145;"
                  fontWeight={800}
                  fontSize={{ xs: 20, md: 32 }}
                  lineHeight={{ xs: "27.5px", md: "44px" }}
                  sx={{ mt: { xs: 2, md: 3 } }}
                >
                  {t.landingPage.title}
                </Typography>

                <Typography
                  textAlign="center"
                  fontFamily="Inter, sans-serif"
                  color="#777"
                  fontWeight={600}
                  fontSize={{ xs: 14, md: 24 }}
                  lineHeight={{ xs: "19.25px", md: "33px" }}
                  sx={{ mt: { xs: 1, md: 2 } }}
                >
                  {t.landingPage.subtitle}
                </Typography>

                {/* Grid Section */}
                <Grid
                  container
                  spacing={{ xs: 2, sm: 4 }}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ mt: { xs: 2, md: 4 } }}
                >
                  {/* Image Section */}
                  <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        mt: { xs: 2, md: 0 },
                      }}
                    >
                      <Box
                        component="img"
                        src={images.certageLandingLogo}
                        alt="Facial Scan"
                        sx={{
                          maxWidth: { xs: "90vw", sm: "70vw", md: "100%" },
                          height: { xs: "220px", sm: "320px", md: "470px" },
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Grid>

                  {/* Text + Button Section */}
                  <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
                    <Typography
                      variant="body1"
                      fontFamily="Inter, sans-serif"
                      color="#777"
                      fontWeight={600}
                      fontSize={{ xs: 12, md: 20 }}
                      textAlign={"center"}
                      lineHeight={{ xs: "19.25px", md: "27.5px" }}
                      sx={{ width: "100%", mb: 2 }}
                    >
                      {t.landingPage.info}
                    </Typography>
                    <Paper
                      elevation={0}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        borderRadius: "14px",
                        border: "1px solid #D4ECFF",
                        background: { xs: "#fff", md: "#FBFDFF" },
                        p: { xs: 2, md: "37px 15px" },
                        boxSizing: "border-box",
                        mb: 2,
                      }}
                    >
                      <Button
                        fullWidth
                        onClick={initiateVerification}
                        sx={{
                          backgroundColor: "#1818de",
                          px: { xs: 0, sm: 5 },
                          py: 1.5,
                          width: "70%",
                          mx: "auto",
                          borderRadius: "12px",
                          mb: 2,
                          fontSize: { xs: 20, sm: 24 },
                          fontWeight: 600,
                          color: "#fff",
                          "&:hover": { backgroundColor: "#1515b0" },
                        }}
                      >
                        {t.landingPage.startButton}
                      </Button>

                      <Typography
                        variant="caption"
                        color="#777"
                        fontFamily="Inter, sans-serif"
                        fontSize={{ xs: "0.7rem", sm: "0.75rem" }}
                        sx={{ width: "100%" }}
                      >
                        {t.landingPage.termsAccept}{" "}
                        <Link
                          onClick={() =>
                            navigate("/terms-and-condition", {
                              state: { language },
                            })
                          }
                          color="primary.text"
                          sx={{ cursor: "pointer" }}
                        >
                          {t.landingPage.termsLink}
                        </Link>{" "}
                        and{" "}
                        <Link
                          onClick={() =>
                            navigate("/privacy-policy", {
                              state: { language },
                            })
                          }
                          color="primary.text"
                          sx={{ cursor: "pointer" }}
                        >
                          {t.landingPage.privacyLink}
                        </Link>
                        . {t.landingPage.noData}
                      </Typography>
                    </Paper>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 2,
                        textAlign: "center",
                        color: "#A1A1A1",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      {t.landingPage.cancel}
                    </Typography>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </>
        )}
      </>
    </ThemeProvider>
  );
};

export default LivenessDetector;
